// In-app browsers (KakaoTalk, Instagram, Facebook, LINE, NAVER …) ignore window.print(), so printing
// sends people to a real browser instead. Many Korean visitors arrive through KakaoTalk links.

export type InAppKind = "kakaotalk" | "other";

export function inAppBrowser(ua: string): InAppKind | null {
  if (/KAKAOTALK/i.test(ua)) return "kakaotalk";
  if (/Instagram|FBAN|FBAV|FB_IAB|\bLine\/|NAVER\(inapp|DaumApps|everytimeApp/i.test(ua)) return "other";
  return null;
}

/** KakaoTalk hands a page to the phone's default browser through its own scheme */
export function kakaoExternalUrl(url: string): string {
  return "kakaotalk://web/openExternal?url=" + encodeURIComponent(url);
}
